import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { TextListWithDot } from "@/components/TextListWithDot";
import { Flex, Tooltip } from "@/eworkitComponents";
import { useFormats } from "@/hooks/Formats";

export interface ITaskSubHeader {
  systemId?: string;
  startDate?: string | null;
  endDate?: string | null;
}

interface ITaskSubHeaderProps {
  entity: ITaskSubHeader;
}

export const WorkOrderSubHeader: FC<ITaskSubHeaderProps> = ({ entity }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();
  const startDate = formatDate(entity.startDate);
  const endDate = formatDate(entity.endDate);

  return (
    <TextListWithDot>
      {!!entity.systemId && <div>{entity.systemId}</div>}
      <Tooltip
        placement="bottom"
        content={t("JOB_REQUESTS.DETAIL.ASSIGNMENT_PERIOD_TOOLTIP", {
          startDate,
          endDate,
        })}>
        <Flex key="dates" innerMargin="xs">
          <Text color="black" text={startDate} />
          <Icon icon="ic_arrow_forward" color="grey1" />
          <Text color="black" text={endDate} />
        </Flex>
      </Tooltip>
    </TextListWithDot>
  );
};
